import styled from '@emotion/styled';
import { boolean } from 'zod';

// Base table container
export const StyledTable = styled.div<{ dark?: boolean }>`
  background-color: ${(props) => (props.dark ? 'var(--colorBlueGray1200)' : 'white')};
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-collapse: collapse;
  width: 700px;
  border: 1px solid ${(props) => (props.dark ? 'var(--colorBlueGray1000)' : 'none')};

  table {
    width: 100%;
    border-spacing: 0;

    thead {
      background-color: ${(props) => (props.dark ? 'var(--colorBlueGray1100)' : 'white')};

      th {
        padding: 1rem;
        text-align: left;
        font-size: 0.875rem;
        font-weight: 500;
        color: ${(props) => (props.dark ? 'var(--colorBlueGray50)' : 'var(--colorBlueGray900)')};
      }
    }

    tbody {
      tr {
        box-shadow: 0 1px 0
          ${(props) => (props.dark ? 'var(--colorBlueGray1000)' : 'var(--colorBlueGray100)')};

        td {
          padding: 1rem;
          font-size: 0.875rem;
          color: ${(props) =>
            props.dark ? 'var(--colorBlueGray100)' : 'var(--colorBlueGray1000)'};

          &.text-right {
            text-align: right;
          }

          &.text-mono {
            font-family: monospace;
          }

          &.amount {
            font-weight: 500;

            &.negative {
              color: #b91c1c;
            }

            &.positive {
              color: ${(props) =>
                props.dark ? 'var(--colorBlueGray50)' : 'var(--colorBlueGray1300)'};
            }
          }
        }
      }
    }
  }
`;
